<template>
  <div class="customer-form">
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      :disabled="disabled"
    >
      <div class="mb-3 d-flex flex-row">
        <div style="flex: 1" class="pr-2">
          <h6 style="color: #101010">
            {{ $l('form_header_base') || '客户信息' }}
          </h6>
          <p style="font-size: 14px; color: #6c6c6c" class="m-0 text-truncate">
            {{
              $l('form_desc_base') ||
              '根据操作指引填写客户基本信息、客户部门及产品线、客户方联系人、客户账务信息、配置对接客户的服务团队成员'
            }}
          </p>
        </div>
      </div>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custName') || '客户公司名称'"
            prop="custName"
          >
            <el-input
              v-model="formData.custName"
              :placeholder="
                $l('form_placeholder_custName') || '请输入客户公司名称'
              "
              maxlength="200"
              show-word-limit
              clearable
            />
            <!-- <el-input v-model="formData.custName" readonly /> -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_businessLicense') || '客户公司税号'"
            prop="businessLicense"
          >
            <el-input
              v-model="formData.businessLicense"
              :placeholder="
                $l('form_placeholder_businessLicense') || '请输入客户公司税号'
              "
              maxlength="50"
              show-word-limit
              clearable
            />
            <!-- <el-input v-model="formData.businessLicense" readonly /> -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_region') || '所在国家'"
            prop="regionCode"
          >
            <dict-select
              v-model="formData.regionCode"
              :selectedLabel.sync="formData.regionName"
              :placeholder="$l('form_placeholder_region') || '请选择所在国家'"
              url="/master/common/dict/biz"
              :body="{ dictType: 'region' }"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_custAddress') || '客户经营地址'"
            prop="custAddress"
          >
            <el-input
              v-model="formData.custAddress"
              :placeholder="
                $l('form_placeholder_custAddress') || '请输入客户经营地址'
              "
              maxlength="500"
              show-word-limit
              clearable
            />
            <!-- <el-input v-model="formData.custAddress" readonly /> -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_contactMobile') || '客户联系电话'"
            prop="contactMobile"
          >
            <el-input
              v-model="formData.contactMobile"
              :placeholder="
                $l('form_placeholder_contactMobile') || '请输入客户联系电话'
              "
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="my-3">
        <h6 style="color: #101010">
          {{ $l('form_header_bizSet') || '业务设置' }}
        </h6>
        <p style="font-size: 14px; color: #6c6c6c" class="m-0 text-truncate">
          {{
            $l('form_desc_bizSet') ||
            '填写该客户在后续业务操作中，所需使用的相关设置定义'
          }}
        </p>
      </div>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_custShortName') || '客户简称'"
            prop="custShortName"
          >
            <el-input
              v-model="formData.custShortName"
              :placeholder="
                $l('form_placeholder_custShortName') || '请输入客户简称'
              "
              maxlength="200"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_customerBizType') || '客户类型'"
            prop="customerBizType"
          >
            <dict-select
              v-model="formData.customerBizType"
              :placeholder="
                $l('form_placeholder_customerBizType') || '请选择客户类型'
              "
              url="/digitalCenter/common/dict/system"
              :body="{ dictType: 'customerBizType' }"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_customerType') || '客户性质'"
            prop="customerType"
          >
            <dict-select
              v-model="formData.customerType"
              :placeholder="
                $l('form_placeholder_customerType') || '请选择客户性质'
              "
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'customerType' }"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_sales') || '接待人员'"
            prop="salesCode"
          >
            <dict-select
              v-model="formData.salesCode"
              :selectedLabel.sync="formData.salesName"
              :placeholder="$l('form_placeholder_sales') || '请选择接待人员'"
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
              size="mini"
              @change="salesChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_riskAssessor') || '财务风险评估人'"
            prop="riskAssessorCode"
          >
            <dict-select
              v-model="formData.riskAssessorCode"
              :selectedLabel.sync="formData.riskAssessorName"
              :placeholder="
                $l('form_placeholder_riskAssessor') || '请选择财务风险评估人'
              "
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_dep') || '业务部门'"
            prop="depCode"
          >
            <dep-cascader
              :lastValue.sync="formData.depCode"
              :pathLabels.sync="formData.orgDepFullName"
              :placeholder="$l('form_placeholder_dep') || '请选择业务部门'"
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_managerApproval') || '部门主管审批人'" prop="managerApprovalBy">
            <dict-select
              v-model="formData.managerApprovalBy"
              :selectedLabel.sync="formData.managerApprovalByName"
              :placeholder="$l('form_placeholder_managerApproval') ||'请选择部门主管审批人'"
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_approver') || '审批负责人'"
            prop="approverCode"
          >
            <dict-select
              v-model="formData.approverCode"
              :selectedLabel.sync="formData.approverName"
              :placeholder="
                $l('form_placeholder_approver') || '请选择审批负责人'
              "
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="mt-3 mb-1">
            <h6>
              <span class="text-danger">*</span>
              <span style="color: #101010">
                {{ $l('form_label_customerBackground') || '客户背景调查' }}
              </span>
            </h6>
            <p
              style="font-size: 14px; color: #6c6c6c"
              class="m-0 text-truncate"
            >
              {{
                $l('form_paragraph_customerBackground') ||
                '填写该客户在后续业务操作中，所需使用的相关设置定义'
              }}
            </p>
          </div>
          <el-form-item prop="customerBackground">
            <template #label> </template>
            <div>
              <Editor
                v-model="formData.customerBackground"
                :disabled="disabled"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="d-flex justify-content-end mt-4" v-if="!disabled">
      <el-button @click="save()" size="small" type="primary">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import Editor from '@/views/digital/components/editor'
export default {
  components: { Editor },
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      rules: {
        custName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custName') || '请输入客户公司名称',
            trigger: 'blur',
          },
        ],
        businessLicense: [
          {
            required: true,
            message:
              this.$l('form_placeholder_businessLicense') ||
              '请输入客户公司税号',
            trigger: 'blur',
          },
        ],
        regionCode: [
          {
            required: true,
            message: this.$l('form_placeholder_region') || '请选择所在国家',
            trigger: 'change',
          },
        ],
        custAddress: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custAddress') || '请输入客户经营地址',
            trigger: 'blur',
          },
        ],
        contactMobile: [
          {
            required: true,
            message:
              this.$l('form_placeholder_contactMobile') || '请输入客户联系电话',
            trigger: 'blur',
          },
        ],
        custShortName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custShortName') || '请输入客户简称',
            trigger: 'blur',
          },
        ],
        customerBizType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customerBizType') || '请选择客户类型',
            trigger: 'change',
          },
        ],
        customerType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customerType') || '请选择客户性质',
            trigger: 'change',
          },
        ],
        riskAssessorCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_riskAssessor') ||
              '请选择财务风险评估人',
            trigger: 'change',
          },
        ],
        salesCode: [
          {
            required: true,
            message: this.$l('form_placeholder_sales') || '请选择接待人员',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message: this.$l('form_placeholder_dep') || '请选择业务部门',
            trigger: 'change',
          },
        ],
        approverCode: [
          {
            required: true,
            message: this.$l('form_placeholder_approver') || '请选择审批负责人',
            trigger: 'change',
          },
        ],
        managerApprovalBy: [
          {
            required: true,
            message: this.$l('form_placeholder_managerApproval') ||'请选择部门主管审批人',
            trigger: 'change',
          },
        ],
        customerBackground: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customerBackground') ||
              '请输入客户背景调查',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body
      this.formData = data
      this.$emit('loaded', { ...data })
    },
    async save() {
      if (!(await validate.formValidate([this.$refs.form]))) return
      if (this.loadingOpen()) return

      const params = {
        ...this.formData,
        custCode: this.custCode,
        smallImageCode: null,
        smallImageUrl: null,
        middleImageCode: null,
        middleImageUrl: null,
        bigImageCode: null,
        bigImageUrl: null,
      }

      const res = await this.$api
        .masterCustomerSaveBaseApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.getData()
    },
    async salesChange(userCode) {
      const getUser = async () => {
        if (!userCode) return {}
        const res = await this.$api
          .sysUserDetailApi({ userCode })
          .catch(() => null)
        return res?.body || {}
      }

      const userInfo = await getUser()
      const { depCode, orgDepFullName } = userInfo
      this.formData.depCode = depCode
      this.formData.orgDepFullName = orgDepFullName
    },
  },
}
</script>
